
export default {

    name: "dynamicProfilingSettingsMixin",

    data() {
        return {
            profilingEnabledPages: [
                'completed',
                'quota',
                'profile',
                'duplicate',
                'quality',
                'maintenance',
                'finished',
                'participated',
                'acceptance'
            ],
        }
    }
}

